var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 50H0V0H50",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 14.7266C28.5057 14.7266 31.3477 13.0739 31.3477 11.0352C31.3477 8.99645 28.5057 7.34375 25 7.34375C21.4943 7.34375 18.6523 8.99645 18.6523 11.0352C18.6523 13.0739 21.4943 14.7266 25 14.7266Z",
    fill: "#E6007A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 42.5977C28.5057 42.5977 31.3477 40.945 31.3477 38.9062C31.3477 36.8675 28.5057 35.2148 25 35.2148C21.4943 35.2148 18.6523 36.8675 18.6523 38.9062C18.6523 40.945 21.4943 42.5977 25 42.5977Z",
    fill: "#E6007A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1282 19.8607C17.8811 16.8246 17.8707 13.5371 16.1052 12.5177C14.3396 11.4984 11.4874 13.1332 9.7345 16.1693C7.98164 19.2053 7.99195 22.4929 9.75752 23.5122C11.5231 24.5316 14.3753 22.8967 16.1282 19.8607Z",
    fill: "#E6007A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2582 33.777C42.0111 30.741 42.0008 27.4534 40.2352 26.4341C38.4696 25.4147 35.6174 27.0496 33.8645 30.0856C32.1116 33.1217 32.122 36.4092 33.8875 37.4286C35.6531 38.4479 38.5053 36.8131 40.2582 33.777Z",
    fill: "#E6007A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1014 37.4342C17.867 36.4149 17.8773 33.1273 16.1244 30.0913C14.3716 27.0552 11.5193 25.4204 9.75374 26.4398C7.98816 27.4591 7.97786 30.7467 9.73071 33.7827C11.4836 36.8187 14.3358 38.4536 16.1014 37.4342Z",
    fill: "#E6007A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2415 23.5014C42.007 22.482 42.0173 19.1945 40.2645 16.1584C38.5116 13.1224 35.6594 11.4875 33.8938 12.5069C32.1282 13.5262 32.1179 16.8138 33.8708 19.8498C35.6236 22.8859 38.4759 24.5207 40.2415 23.5014Z",
    fill: "#E6007A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21);
export default __webpack_public_path__ + "static/media/21.d901efc7bf753a0573b35fd2f2d44c59.svg";
export { ForwardRef as ReactComponent };